import React from 'react';
import { MuiMarkdown } from '@lsoft/mui';

import DE from '../src/markdown/customer_card.de.md';
import EN from '../src/markdown/customer_card.en.md';
import FR from '../src/markdown/customer_card.fr.md';

import { ShopPage } from '../src/app/ShopPage';
import { getTranslation } from '@lsoft/translate';
import { shopServerSideProps } from '../src/tools/withShopPropsContext';
import { Grid } from '@material-ui/core';
import { ContactData } from '../src/components/Contact/ContactData';

const CustomerCard = (pageProps) => {
	return (
		<ShopPage {...pageProps} noLogin variant={'sidebarMenu'}>
			<Grid container spacing={2}>
				<Grid item xs={12} md={8}>
					<MuiMarkdown tr={{ DE, EN, FR }} />
				</Grid>
				<Grid item xs={12} md={4}>
					<ContactData />
				</Grid>
			</Grid>
		</ShopPage>
	);
};

export const getServerSideProps = shopServerSideProps(async ({ locale }) => {
	return {
		props: {
			pageInfo: {
				title: getTranslation(
					{
						DE: 'Kundenkarte',
						EN: 'Customer Card',
						FR: 'Carte client',
					},
					locale
				),
			},
		},
	};
});
export default CustomerCard;
